import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import apolloProvider from './plugins/vue-apollo';
import { abilitiesPlugin } from '@casl/vue';
import { Ability } from '@casl/ability';
import Notifications from 'vue-notification'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.config.productionTip = false
const ability = new Ability([]);
Vue.use(abilitiesPlugin, ability);
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
Vue.use(Notifications)
Vue.use(CKEditor)
Vue.use(Viewer)


function getInitialLocale() {
  const saved = localStorage.getItem('locale');
  if (saved) return saved;
  if (typeof navigator !== 'undefined') {
    const lang = (navigator.language || (navigator.languages && navigator.languages[0]) || '').toLowerCase();
    if (lang.startsWith('ar')) {
      return 'ar';
    }
  }
  return 'en';
}

const savedLocale = getInitialLocale();
if (typeof document !== 'undefined') {
  document.dir = savedLocale === 'ar' ? 'rtl' : 'ltr';
}

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    ar: require('./locales/ar.json'),
    en: require('./locales/en.json')
  }
})
new Vue({
  router,
  store,
  vuetify,
  i18n,
  apolloProvider,
  render: function (h) { return h(App) },
  data: {
    ability
  }
}).$mount('#app')
